var lib_core = require("lib-core");
var AbstractInteractionModel = lib_core.AbstractInteractionModel;
var PathHandleModel = require("../svg/pathViewer/pathHandleModel.js");

/**
 * @constructor
 */
var SelectionStateMachine = function (root, model, cameraModel) {
    var self = this;
    this.root = root;
    this.model = model;
    this.cameraModel = cameraModel;

    lib_core.StateMachine.call(self);

    this.getCurrentSelectable = function(cEvent) {
        var currentSelectable;
        if (cEvent.element().parentGroup && !cEvent.element().parentGroup.isInFocus()) {
            currentSelectable = cEvent.element().parentGroup;
        } else {
            currentSelectable = cEvent.element();
        }
        return currentSelectable;
    };

    this.elementMouseDownTransition = self.addTransition("idle", "mouse_down",
        function(cEvent){
            return cEvent.type() == lib_core.GuiEvents.ELEMENT_MOUSE_DOWN && !cEvent.data('shiftKey');
        },
        function(cEvent){
            var currentTimeStamp = cEvent.timestamp();
            var currentSelectable = self.getCurrentSelectable(cEvent);

            // (1) doing this before the subelement operation below so it does not get deleted after being added
            if (!self.model.selection.contains(currentSelectable)) {
                self.model.emptySelection();
            }

            // (2) do this before the add to the selection model so listeners can benefit from this information
            if (cEvent.element('subelement')) {
                self.model.selectedSubElement(cEvent.element('subelement'));
            }
            else if(self.model.selectedSubElement()) {
                self.model.selectedSubElement(null);
            }
            self.model.clickedElement(currentSelectable);

            // (3) must go after 1,2
            if (!self.model.selection.contains(currentSelectable)) {
                self.model.selection.add(currentSelectable);
                self.previousSelected = currentSelectable;
                self.previousSelectedTimestamp = currentTimeStamp;
            }

            // here we do not want to empty the group, because move() depends on them all
            // still being in the group, but we want to specify which object should control snapping
            if(self.snapModel != null) {
                self.model.snapModel.addToGroup(cEvent.element());
                self.model.snapModel.snapControlFrom(cEvent.element());
            }

            self.elementClicked = cEvent.element();
            if (cEvent.element('subelement')) {
                self.subelementClicked = cEvent.element('subelement');
            } else {
                self.subelementClicked = null;
            }

            // grab the mouse position
            self.startCoord = self.cameraModel.toRealCoord(cEvent.data('mouseCoord'));
        }
    );

    this.mouseUpTransition = self.addTransition("mouse_down","idle",
        function(cEvent) {
            return cEvent.type() == lib_core.GuiEvents.CANVAS_MOUSE_UP || cEvent.type() == lib_core.GuiEvents.EDITOR_MOUSE_UP;
        },
        function (cEvent) {
            var currentTimeStamp = cEvent.timestamp();
            var realCoord = self.cameraModel.toRealCoord(cEvent.data('mouseCoord'));

            if (self.elementClicked) {
                if ((self.elementClicked == self.previousElementClicked)
                    && (currentTimeStamp-self.previousClickedTimestamp < 500)) {
                    self.previousElementClicked = null;
                    self.previousClickedTimestamp = 0;
                    if (self.elementClicked.doubleClickAction){
                        self.root.rec();
                        self.elementClicked.doubleClickAction(realCoord, self.subelementClicked);
                        self.root.stopRec();
                    }
                } else {
                    self.previousElementClicked = self.elementClicked;
                    self.previousClickedTimestamp = currentTimeStamp;
                    if (self.elementClicked.clickAction){
                        self.elementClicked.clickAction(realCoord, self.subelementClicked);
                    }
                    self.model.onElementClicked();
                }
            }
        }
    );

    self.addTransition("idle","idle",
        function(cEvent){
            return cEvent.type() == lib_core.GuiEvents.ELEMENT_MOUSE_DOWN && cEvent.data('shiftKey');
        },
        function(cEvent){
            var currentTimeStamp = cEvent.timestamp();
            var currentSelectable = self.getCurrentSelectable(cEvent);

            if (!self.model.selection.contains(currentSelectable) &&
                (currentSelectable instanceof AbstractInteractionModel ||
                currentSelectable instanceof PathHandleModel)) {
                self.model.selection.add(currentSelectable);
                self.previousSelected = currentSelectable;
                self.previousSelectedTimestamp = currentTimeStamp;
                self.model.onElementSelected();

            } else { // deselect
                self.model.removeFromSelection(currentSelectable);
                self.previousSelected = null;
                self.previousSelectedTimestamp = 0;
            }
        }
    );

    self.addTransition("idle","selecting",
        function(cEvent){
            return cEvent.type() == lib_core.GuiEvents.CANVAS_MOUSE_DOWN && cEvent.data('shiftKey');
        },
        function(cEvent){
            self.model.selection_box_start(self.cameraModel.toRealCoord(cEvent.data('mouseCoord')));
            self.model.selection_box_end(self.cameraModel.toRealCoord(cEvent.data('mouseCoord')));
        }
    );

    self.addTransition("selecting", "selecting",
        function(cEvent) {
            return cEvent.type() == lib_core.GuiEvents.EDITOR_MOUSE_MOVE ;
        },
        function (cEvent) {
            self.model.selection_box_end(self.cameraModel.toRealCoord(cEvent.data('mouseCoord')));
        }
    );

    self.addTransition("selecting", "idle",
        function(cEvent) {
            return cEvent.type() == lib_core.GuiEvents.CANVAS_MOUSE_UP || cEvent.type() == lib_core.GuiEvents.EDITOR_MOUSE_UP ;
        },
        function (cEvent) {
            self.model.selection_box_end(null);
            self.model.selection_box_start(null);
        }
    );

    this.addEventAction("idle",
        function(cEvent){
            return cEvent.isKeyPressed('C_i');
        },
        function(cEvent){
            self.model.invertSelection();
        }, "Invert selection"
    );

    this.addEventAction("idle",
        function(cEvent) {
            return cEvent.isKeyPressed('C_d');
        },
        function(cEvent) {
            self.model.emptySelection();
        },
        "Empty selection"
    );

    this.addEventAction("idle",
        function(cEvent) {
            return cEvent.isKeyPressed('C_a');
        },
        function(cEvent) {
            var selectables = self.model.selectables();
            self.model.selection.addAll(selectables);
        },
        "All selection"
    );

    this.addEventAction("idle",
        function(cEvent) {
            return cEvent.isKeyPressed('escape') ||
                   cEvent.type() == lib_core.GuiEvents.UNDO_BUTTON ||
                   cEvent.type() == lib_core.GuiEvents.REDO_BUTTON;
        },
        function(cEvent) {
            self.model.emptySelection();
        },
        "Escape pressed"
    );

    this.addEventAction("idle",
        function(cEvent){
            return cEvent.type() == lib_core.GuiEvents.CANVAS_MOUSE_DOWN;
        },
        function(cEvent){
            self.model.emptySelection();
        }
    );
};

lib_core.inherit(SelectionStateMachine, lib_core.StateMachine);

module.exports = SelectionStateMachine;
